export enum Role {
    admin = "admin",
    institution = "institution",
    user = "user"
}